<template>
  <div class="content-main">

    <div class="ptitle">添加省钱助手</div>
    <div class="ptitle">即可加入省钱群</div>
    <div class="ptitle">👇 👇 👇 </div>
    <!-- <img class="qrcode" src="https://static.huiyiji520.com/670532441.jpg"> -->
    <img class="qrcode" src="https://static.huiyiji520.com/qrcode_chihuo_1733048621.jpg">
    <div class="hints">
      <div class="hint">外卖红包/打车券/电影券/酒店券/特价商品捡漏</div>
      <div class="hint">每个月至少可以帮你省大几百块</div>
    </div>

  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
// import { Toast, Dialog, Popup } from 'vant'

export default{
  data(){
    return {

    }
  },
  methods: {
    setHtmlFontSize () {
      const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      const htmlDom = document.getElementsByTagName('html')[0]
      htmlDom.style.fontSize = htmlWidth / 10 + 'px'
    }
  },
  mounted(){
    this.setHtmlFontSize()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#333;padding-top:30%;}

.ptitle{font-size:32px;font-weight:bold;margin-bottom:8px;}
.qrcode{
  width:320px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;
  box-shadow:0px 2px 6px rgba(0,0,0,0.15);
}
.account{font-weight:bold;color:#b17e94;}
.hints{font-size:30px;}
.hints .hint{margin-bottom:16px;}
</style>
